import React from 'react';
import '../../styles/cards.css';

export default function Card({ title, icon, iconClass = 'ib', subtitle, headerRight, children, noPad }) {
  return (
    <div className="card">
      <div className="chdr">
        <div className="ctit">
          {icon && <div className={`cico ${iconClass}`}>{icon}</div>}
          {title}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {subtitle && <span className="csub">{subtitle}</span>}
          {headerRight}
        </div>
      </div>
      <div className={noPad ? 'cbf' : 'cbody'}>
        {children}
      </div>
    </div>
  );
}
